/* eslint-disable import/prefer-default-export */
/* eslint-disable import/no-cycle */
import { createActions } from 'redux-actions';
import { ROOT_SLICE } from '../constants';

const {
	set,
	setCustomer,
	setIsLoadingLoaded,
	setErrorMessage,
	clear,
	addDeletingLineAggId,
	removeDeletingLineAggId,
	addDeletedLineAggId,
	removeDeletedLineAggId,
	addErrorMessageForDeleting,
	removeErrorMessageForDeleting,
	clearErrorMessagesForDeleting
} = createActions(
	{
		SET: ({ items }) => ({ items }),
		SET_CUSTOMER: customerName => ({ customer: customerName }),
		SET_IS_LOADING_LOADED: ({ isLoading, isLoaded }) => ({
			isLoading,
			isLoaded
		}),
		SET_ERROR_MESSAGE: errorMessage => ({ errorMessage }),
		CLEAR: () => ({}),

		ADD_DELETING_LINE_AGG_ID: lineAggId => ({ lineAggId }),
		REMOVE_DELETING_LINE_AGG_ID: lineAggId => ({ lineAggId }),

		ADD_DELETED_LINE_AGG_ID: lineAggId => ({ lineAggId }),
		REMOVE_DELETED_LINE_AGG_ID: lineAggId => ({ lineAggId }),

		ADD_ERROR_MESSAGE_FOR_DELETING: (lineAggId, errorMessage) => ({
			lineAggId,
			errorMessage
		}),
		REMOVE_ERROR_MESSAGE_FOR_DELETING: lineAggId => ({ lineAggId }),
		CLEAR_ERROR_MESSAGED_FOR_DELETING: () => ({})
	},
	{ prefix: ROOT_SLICE }
);

export {
	set,
	setCustomer,
	setIsLoadingLoaded,
	setErrorMessage,
	clear,
	addDeletingLineAggId,
	removeDeletingLineAggId,
	addDeletedLineAggId,
	removeDeletedLineAggId,
	addErrorMessageForDeleting,
	removeErrorMessageForDeleting,
	clearErrorMessagesForDeleting
};
